<template>
  <div>
    <div
      class="is-size-6 level-left"
      style="padding-bottom: 20px"
    >Total properties: {{ totalProperties }}&nbsp;<div v-if="totalProperties > 6">({{ perPage }} per page)</div>
    </div>

    <!-- Total: {{ totalProperties }}<br>
    Current: {{ current }}<br>
    Per page: {{ perPage }}<br>
    Range before: {{ rangeBefore }}<br>
    Range after: {{ rangeAfter }} -->

    <div
      class="level-item"
      style="margin-bottom: 0.5em"
    >
      <b-pagination
        v-if="totalProperties > 6"
        :total="totalProperties"
        :current.sync="current"
        :range-before="rangeBefore"
        :range-after="rangeAfter"
        :order="order"
        :size="size"
        :simple="isSimple"
        :rounded="isRounded"
        :per-page="perPage"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
      </b-pagination>
    </div>

    <div class="container is-fluid">
      <div class="columns is-multiline">
        <div
          class="column is-one-third"
          v-for="property in propertiesToDisplay"
          :key="property.id"
        >
          <PropertyCard :property="property" />
        </div>
      </div>
    </div>

    <div
      class="level-item"
      style="margin-top: 0.5em"
    >
      <b-pagination
        v-if="totalProperties > 6"
        :total="totalProperties"
        :current.sync="current"
        :range-before="rangeBefore"
        :range-after="rangeAfter"
        :order="order"
        :size="size"
        :simple="isSimple"
        :rounded="isRounded"
        :per-page="perPage"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
      </b-pagination>
    </div>

    <section
      class="section"
      v-if="this.$store.state.properties.length == 0"
    >
      <div class="content has-text-grey has-text-centered">
        <p>
          <b-icon
            icon="emoticon-happy"
            size="is-large"
          >
          </b-icon>
        </p>
        <p>No properties.<br>Click New Property button<br>or change filter settings.</p>
      </div>
    </section>

  </div>
</template>

<script>
import PropertyCard from "@/components/properties/PropertyCard.vue";

export default {
  components: {
    PropertyCard
  },

  computed: {
    totalProperties() {
      return this.$store.state.properties.length;
    },
    propertiesToDisplay() {
      // Display just the properties for the page we are on.
      return this.$store.state.properties.slice(
        this.current * this.perPage - this.perPage,
        this.current * this.perPage
      );
    }
  },

  data() {
    return {
      current: 1,
      perPage: 6,
      rangeBefore: 6,
      rangeAfter: 6,
      order: "is-centered",
      size: "",
      isSimple: true,
      isRounded: false
    };
  }
};
</script>

<style>
</style>
